import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-65d8b080"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "text-center font-bold",
  style: {
    "padding-top": "100px"
  }
};
const _hoisted_2 = {
  key: 1,
  style: {
    "margin": "0 10px 10px 10px",
    "padding-top": "10px"
  }
};
const _hoisted_3 = {
  style: {
    "padding-left": "10px"
  }
};
const _hoisted_4 = {
  style: {
    "margin": "20px 5px 10px 5px",
    "padding": "10px"
  },
  class: "bg-white"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 0,
  style: {
    "padding-top": "10px",
    "padding-left": "10px"
  }
};
const _hoisted_7 = {
  style: {
    "line-height": "24px",
    "color": "#333",
    "font-weight": "bold"
  }
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "line-height": "24px",
    "color": "#333",
    "font-weight": "bold"
  }
}, "知识点：", -1));
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = {
  class: "font-bold flex align-center justify-center",
  style: {
    "margin-top": "20px"
  }
};
const _hoisted_13 = ["disabled"];
const _hoisted_14 = ["disabled"];
import { onMounted, ref, reactive, computed } from "vue";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
import { questionList, articleComplete, articleNext, questionSubmit } from "../../../api/index";
import { getLocalPid } from "../../../libs/util";
import problemItem from "../practice/problemItem.vue";
const title = "请完成以下练习：";
export default {
  __name: 'questions',
  props: {
    articleId: {
      type: [Number, String],
      default: 0
    },
    readLogId: {
      type: [Number, String],
      default: 0
    },
    timestamp: {
      type: [Number, String],
      default: 0
    }
  },
  setup(__props) {
    const store = useStore();
    const safeMes = computed(() => store.state.safeMes);
    onMounted(() => {
      getProblems();
    });
    const props = __props;
    let isCompleted = false;
    const activeSentenceIndex = ref(-2);
    const data = reactive({
      questions: [],
      answerList: []
    });
    const waiting = ref(true);
    const disabled = ref(false);
    const isSubmit = ref(false);
    const getCorrectAnswerTag = questIdx => {
      let q = data.questions[questIdx];
      let a = q.answer;
      if (a == q.selectA) return "A";
      if (a == q.selectB) return "B";
      if (a == q.selectC) return "C";
      if (a == q.selectD) return "D";
      return "";
    };
    const chooseSentence = index => {
      if (activeSentenceIndex.value == index) {
        return activeSentenceIndex.value = -2;
      }
      activeSentenceIndex.value = index;
    };
    const getProblems = () => {
      let obj = {
        ...safeMes.value,
        articleId: props.articleId,
        readLogId: props.readLogId,
        timestamp: props.timestamp
      };
      questionList(encodeURIComponent(JSON.stringify(obj))).then(res => {
        if (res.data.code) return store.commit("judgeCode", {
          code: res.data.code,
          msg: res.data.msg
        });
        data.questions = res.data.data.questions;
        waiting.value = false;
        while (data.questions.length != data.answerList.length) {
          data.answerList.push("");
        }
      }).catch(() => {
        waiting.value = false;
        ElMessage.error("获取题目失败");
      });
    };
    const getAns = val => {
      let item = {
        answer: val.ans,
        questionId: data.questions[val.index].id
      };
      data.answerList.splice(val.index, 1, item);
      if (!isCompleted) {
        completeReading();
      }
    };
    const completeReading = () => {
      isCompleted = true;
      let obj = {
        ...safeMes.value,
        articleId: props.articleId,
        readLogId: props.readLogId,
        timestamp: props.timestamp
      };
      articleComplete(encodeURIComponent(JSON.stringify(obj))).then(() => {}).catch(() => {
        isCompleted = false;
      });
    };
    const submitOrNextArticle = () => {
      console.log("submitOrNextArticle");
      disabled.value = true;
      if (isSubmit.value) {
        nextArticle();
      } else {
        submitAnswers();
      }
    };
    const nextArticle = () => {
      console.log("nextArticle");
      disabled.value = true;
      let obj = {
        ...safeMes.value,
        articleId: props.articleId,
        readLogId: props.readLogId,
        timestamp: props.timestamp,
        reason: "next",
        pid: getLocalPid()
      };
      articleNext(encodeURIComponent(JSON.stringify(obj))).then(res => {
        if (res.data.code) {
          return store.commit("judgeCode", {
            code: res.data.code,
            msg: res.data.msg
          });
        }
        let href = window.location.href;
        window.location.href = href.substring(0, href.lastIndexOf("/")) + "/article?id=" + res.data.data.articleId + "&pid=" + getLocalPid();
      }).catch(() => {
        return ElMessage.error("获取文章失败");
      });
    };
    const submitAnswers = () => {
      disabled.value = true;
      let index = data.answerList.findIndex(v => v === "");
      if (index != -1) return ElMessage.warning("请填写所有题目哦");
      let obj = {
        ...safeMes.value,
        articleId: props.articleId,
        readLogId: props.readLogId,
        answers: data.answerList
      };
      console.log("submitAnswers", obj);
      questionSubmit(encodeURIComponent(JSON.stringify(obj))).then(res => {
        if (res.data.code) return store.commit("judgeCode", {
          code: res.data.code,
          msg: res.data.msg
        });
        ElMessage.success("提交成功");
        disabled.value = false;
        isSubmit.value = true;
      }).catch(err => {
        disabled.value = false;
        console.log(err);
        ElMessage.error("提交答案失败");
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [!data.questions.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(waiting.value ? "题目获取中..." : "暂时没有题目哦!"), 1), !waiting.value && !data.questions.length ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        style: {
          "margin-left": "10px",
          "padding": "0 10px 0 10px"
        },
        onClick: getProblems
      }, " 重试 ")) : _createCommentVNode("", true)])) : _createCommentVNode("", true), data.questions.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", {
        style: {
          "color": "#333",
          "margin-left": "4px"
        },
        class: _normalizeClass(["font-bold", activeSentenceIndex.value == -1 ? 'active' : '']),
        onClick: _cache[0] || (_cache[0] = $event => chooseSentence(-1)),
        innerHTML: title
      }, null, 2)])])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.questions, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
          style: {
            "padding": "20px",
            "font-size": "10px",
            "background-color": "#f7f7f7",
            "border": "1px solid #ddd",
            "line-height": "24px"
          },
          class: "font-bold",
          innerHTML: item.title
        }, null, 8, _hoisted_5), _createVNode(problemItem, {
          aProblem: [item.selectA, item.selectB, item.selectC, item.selectD],
          tag: item.id + '',
          index: index,
          onGetAns: getAns
        }, null, 8, ["aProblem", "tag", "index"]), isSubmit.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, [_createTextVNode(" 您的答案： " + _toDisplayString(data.answerList[index].answer) + " ", 1), _hoisted_8, _createTextVNode(" 正确答案： ")]), _createElementVNode("span", {
          style: _normalizeStyle([{
            "line-height": "24px",
            "color": "#333",
            "font-weight": "bold"
          }, data.questions[index]['select' + data.answerList[index].answer] == data.questions[index].answer ? '' : 'color:red;'])
        }, _toDisplayString(getCorrectAnswerTag(index)), 5), _hoisted_9, _hoisted_10, _createElementVNode("div", {
          style: {
            "line-height": "24px",
            "font-weight": "bold",
            "margin-left": "20px"
          },
          innerHTML: data.questions[index].explanation
        }, null, 8, _hoisted_11)])) : _createCommentVNode("", true)])]);
      }), 128)), _createElementVNode("div", _hoisted_12, [data.questions.length ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: {
          "margin-bottom": "50px",
          "padding": "8px 14px",
          "border": "1px solid #d3d3d3",
          "border-radius": "4px"
        },
        class: "bg-white hover",
        onClick: submitOrNextArticle,
        disabled: disabled.value
      }, _toDisplayString(isSubmit.value ? "下一篇" : "提交"), 9, _hoisted_13)) : _createCommentVNode("", true), !data.questions.length ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        style: {
          "margin-bottom": "50px",
          "padding": "8px 14px",
          "border": "1px solid #d3d3d3",
          "border-radius": "4px"
        },
        class: "bg-white hover",
        onClick: nextArticle,
        disabled: disabled.value
      }, " 下一篇 ", 8, _hoisted_14)) : _createCommentVNode("", true)])]);
    };
  }
};